import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IReference } from '@shared/interfaces/reference.interface';

@Component({
    selector: 'app-sidebar-reference-about',
    templateUrl: './sidebar.reference.about.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SidebarReferenceAboutComponent implements OnInit {
  @Input() public reference: IReference;

  constructor() {}

  ngOnInit(): void {}
}
